'use client'

import RenderInView from '@/app/(site)/components/render-in-view'
import { cn } from '@/util/cn'
import { AnimatePresence, motion } from 'framer-motion'
import Typography from '@/app/components/typography'
import { ReactNode } from 'react'

type Props = {
    title: string
    description?: ReactNode
    src?: string
    beforeTitle?: ReactNode
    classNames?: Partial<Record<'base' | 'imgWrapper' | 'img' | 'title', string>>
}

const SectionTitle = ({ title, description, src, beforeTitle, classNames }: Props) => (
    <div className={cn('text-center [--img-dimension:9.375rem]', classNames?.base)}>
        <div className={cn('h-(--img-dimension)', classNames?.imgWrapper)}>
            <AnimatePresence>
                <RenderInView>
                    <motion.div
                        key={src}
                        className={cn('h-(--img-dimension) inline-block mx-auto w-auto', classNames?.img)}
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        exit={{ scale: 0 }}
                        transition={{
                            duration: 0.6,
                            delay: 0.1,
                            ease: [0.175, 0.885, 0.32, 1.275],
                        }}
                    >
                        {beforeTitle}

                        {src && (<img 
                            src={src} 
                            alt={title}
                            className="h-(--img-dimension)"
                        />)}
                    </motion.div>
                </RenderInView>
            </AnimatePresence>
        </div>

        <div className="grid gap-5">
            <Typography
                variant="h1"
                as="h2"
                fontFamily="nexaBlack"
                className={cn('mx-auto', classNames?.title)}
            >{title}</Typography>

            {description && (
                <Typography
                    variant="text-xl"
                    className="max-w-[56.25rem] mx-auto"
                >
                    {description}
                </Typography>
            )}
        </div>
    </div>
)

export default SectionTitle
